import { ExternalLink, TrendingUp } from 'lucide-react'

type TopPost = {
  post_id: string
  shortcode: string
  username: string
  caption?: string
  timestamp?: number
  full_name?: string
  engagement_rate?: number
}

export function TopPostsList({ topPosts }: { topPosts?: TopPost[] }) {
  if (!topPosts || topPosts.length === 0) {
    return (
      <div className="space-y-3">
        <div className="text-sm text-muted-foreground">Top posts from competitors</div>
        <div className="text-center py-8">
          <TrendingUp className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
          <p className="text-sm text-muted-foreground">No standout posts found</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      <div className="text-sm text-muted-foreground">Top posts from competitors</div>
      <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-muted scrollbar-track-transparent">
        {topPosts.slice(0, 5).map((post) => {
          const caption = post.caption || "No caption available"
          const truncatedCaption = caption.length > 100 ? `${caption.substring(0, 100)}...` : caption
          
          return (
            <a 
              key={post.post_id}
              href={`https://instagram.com/p/${post.shortcode}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 rounded-lg border hover:shadow-md transition-all duration-200 cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="text-xs font-medium text-blue-600 dark:text-blue-400">
                    @{post.username}
                  </div>
                  {post.timestamp && (
                    <span className="text-xs text-muted-foreground">
                      {new Date(post.timestamp * 1000).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-1">
                  <ExternalLink className="h-3 w-3 text-muted-foreground" />
                  <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors">
                    View Post
                  </span>
                </div>
              </div>
              
              <p className="mb-3 text-sm text-muted-foreground line-clamp-2">
                {truncatedCaption}
              </p>
              
              <div className="flex items-center justify-between">
                <div className="text-xs text-muted-foreground">
                  {post.full_name || post.username}
                </div>
                {post.engagement_rate && (
                  <div className="flex items-center gap-2">
                    <div className="w-16 bg-muted rounded-full h-2">
                      <div 
                        className="h-2 bg-green-500 rounded-full"
                        style={{ width: `${Math.min(post.engagement_rate * 100, 100)}%` }}
                      />
                    </div>
                    <span className="font-bold text-green-700 text-sm">
                      {(post.engagement_rate * 100).toFixed(3)}%
                    </span>
                  </div>
                )}
              </div>
            </a>
          )
        })}
      </div>
    </div>
  )
}


